<template>
    <b-row>
        <b-col md="6" lg="6">
            <b-card class="mb-1" no-body>
                <div class="card-header p-2 cursor-pointer" @click.stop.prevent="selectHamlet">
                    <div class="col-md-10 pl-0 d-flex">
                        <span class="text-muted d-none">SYSTEM</span>
                        <h5 class="m-0 pl-1">
                            {{ $t('Component(RequestEmailOptions):default-hamlet-configuration') }}
                            ({{ systemEmail }})
                        </h5>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end">
                        <div>
                            <b-form-radio
                                v-model="transport"
                                name="transport"
                                value="hamlet"
                            />
                        </div>
                    </div>
                </div>
            </b-card>
            <b-card class="mb-1" v-for="configuration in configurations.filter(c => c.valid)" no-body>
                <div class="card-header p-2 cursor-pointer" @click.stop.prevent="() => selectConfiguration(configuration)">
                    <div class="col-md-10 pl-0 d-flex">
                        <span class="text-muted text-uppercase d-none">{{ configuration.type }}</span>
                        <h5 class="m-0 pl-1">{{ configuration.username }}</h5>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end">
                        <div>
                            <b-form-radio
                                v-model="transport"
                                name="transport"
                                :value="configuration.id"
                            />
                        </div>
                    </div>
                </div>
            </b-card>
        </b-col>
        <b-col md="6" lg="6">
            <b-card no-body :border-variant="smtpVariant">
                <div class="card-header p-2 cursor-pointer" @click="smtpFormVisible = !smtpFormVisible">
                    <div class="col-md-6 pl-0">
                        <h5 class="m-0">
                            {{ $t('Component(RequestEmailOptions):configure-smtp') }}
                        </h5>
                    </div>
                    <div class="col-md-6 d-flex justify-content-end">
                        <div>
                            <feather-icon :icon="smtpFormVisible ? 'ChevronDownIcon' : 'ChevronRightIcon'" />
                        </div>
                    </div>
                </div>
                <Transition mode="out-in" name="fade">
                    <div class="pl-2 pr-2 pb-1" v-if="smtpFormVisible">
                        <b-alert
                            variant="danger"
                            v-if="smtpValid === false"
                            @dismissed="smtpValid = null"
                            dismissible
                            show
                        >
                            <div class="alert-body">
                                <span>
                                    {{ $t('Component(RequestEmailOptions):configure-smtp-validation-failed') }}
                                </span>
                            </div>
                        </b-alert>
                        <b-overlay
                            variant="white"
                            :show="validatingSmtpDetails"
                            spinner-variant="primary"
                            blur="0"
                            opacity=".85"
                            rounded="sm"
                        >
                            <ConfigureEmailProviderV2
                                @configuration="addConfiguration"
                            />
                        </b-overlay>
                    </div>
                </Transition>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import {
    BCol, BRow, BCard, BFormGroup, BCardTitle, BFormRadio, BFormInput, BInputGroupAppend,
    BAlert, BSpinner, BOverlay, BButton, BInputGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required, email, integer } from '@validations'
import {SystemApi} from "@core/api";
import {togglePasswordVisibility} from "@core/mixins";
import {Button} from "@core/components/common/index";
import ConfigureEmailProviderV2 from "@core/components/common/ConfigureEmailProviderV2";

export default {
    mixins: [togglePasswordVisibility],
    components: {
        BCard, BFormGroup, BCardTitle, BFormRadio, BButton, BInputGroup, BInputGroupAppend,
        BFormInput, BCol, BRow, BAlert, BSpinner, BOverlay, Button,
        ConfigureEmailProviderV2,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            transport: 'hamlet',

            smtpValidated: false,
            smtpResolved: null,
            smtpFormVisible: false,
            smtpValid: null,

            emailValue: '',
            password: '',
            host: '',
            port: '',

            userEmail: '',

            resolvingSmtpDetails: false,
            validatingSmtpDetails: false,

            configurations: [],
            selectedConfiguration: null,

            smtpId: null,
            maxAwaitIterations: 2,
            awaitIteration: 0,
            required,
            email,
            integer
        };
    },
    methods: {
        selectHamlet() {
            this.transport = 'hamlet';
            this.selectedConfiguration = null;

            this.$emit('input', 'system');
        },
        selectConfiguration(configuration) {
            this.selectedConfiguration = configuration;
            this.transport = configuration.id;

            this.$emit('input', configuration.type, configuration.id);
        },
        onEmailChange() {
            console.log('email change');
            // this.resolvingSmtpDetails = true;
        },
        addConfiguration(configuration) {
            this.smtpFormVisible = false;
            this.configurations.push(configuration);
            this.selectConfiguration(configuration);
        },
        setSelectedState() {
            const preferences = this.$store.getters.sendEmailPreferences;
            if (preferences) {
                if (this.configurationTypes.includes(preferences.transport)) {
                    this.transport = preferences.transportConfiguration.id;
                    this.$emit('initialized', preferences.transport, preferences.transportConfiguration.id);
                }
                this.selectedConfiguration = preferences.configuration;
            }
        }
    },
    computed: {
        smtpVariant() {
            if (this.smtpValidated) {
                if (this.smtpValid === null) {
                    return 'light';
                }
                return this.smtpValid === false ? 'danger' : 'success';
            }

            return this.validatingSmtpDetails ? 'warning' : 'light';
        },
        isTransportHamletEmail() {
            return this.transport === 'hamlet';
        },
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
        systemEmail() {
            if (!this.$store.getters.attributes.email) {
                return '';
            }
            return this.$store.getters.attributes.email.sendRequest || '';
        },
        configurationTypes() {
            return this.$store.getters.emailConfigurationTypes.toArray();
        }
    },
    created() {
        SystemApi.email.getConfigurations().then(r => {
            this.configurations = r.data

            if (0 === this.configurations.length) {
                this.smtpFormVisible = true;
            }

            this.setSelectedState();
        });
    }
}
</script>
